import { FC, Suspense, lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { MenuTestPage } from '../pages/MenuTestPage'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import AdminProtectedRoute from './AdminProtectedRoute'

const PrivateRoutes = () => {
  const UsersPage = lazy(() => import('../modules/apps/users/UsersPage'))
  const ClientsPage = lazy(() => import('../modules/apps/clients/ClientsPage'))
  const QuotesPage = lazy(() => import('../modules/apps/orders/QuotesPage'))
  const SchedulePage = lazy(() => import('../modules/apps/schedule/SchedulePage'))
  const ProductPage = lazy(() => import('../modules/apps/products/ProductsPage'))
  // const FactoryOrdersPage = lazy(() => import('../modules/apps/factory-orders/FactoryOrdersPage'))
  const QuoteDetailspage = lazy(() => import('../modules/apps/orders/QuoteDetailsPage'))
  const CompanySettingsPage = lazy(() => import('../modules/apps/company-settings/CompanySettingsPage'))
  const CompaniesPage = lazy(() => import('../modules/apps/companies/CompaniesPage'))
  const BudgetManagementPage = lazy(() => import('../modules/apps/budget-management/BudgetManagementPage'))
  const RenovacaoPage = lazy(() => import('../modules/apps/renovacao/RenovacaoPage'))
  const CommissionsPage = lazy(() => import('../modules/apps/commissions/CommissionsPage'))
  const CommissionDetailsPage = lazy(() => import('../modules/apps/commissions/CommissionDetailsPage'))
  //const DrawingPage = lazy(() => import('../modules/apps/drawing/DrawingPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route
          path='pedidos/*'
          element={
            <SuspensedView>
              <QuotesPage />
            </SuspensedView>
          }
        />
        <Route
          path='pedidos/:orderId/*'
          element={
            <SuspensedView>
              <QuoteDetailspage />
            </SuspensedView>
          }
        />
        <Route
          path='usuarios/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='clientes/*'
          element={
            <SuspensedView>
              <ClientsPage />
            </SuspensedView>
          }
        />
        <Route
          path='agendamentos/*'
          element={
            <SuspensedView>
              <SchedulePage />
            </SuspensedView>
          }
        />
        <Route
          path='produtos/*'
          element={
            <SuspensedView>
              <ProductPage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='pedidos-de-fabrica/*'
          element={
            <SuspensedView>
              <FactoryOrdersPage />
            </SuspensedView>
          }
        /> */}
        <Route
          path='empresa'
          element={
            <SuspensedView>
              <CompanySettingsPage />
            </SuspensedView>
          }
        />
        <Route
          path='renovacao'
          element={
            <SuspensedView>
              <RenovacaoPage />
            </SuspensedView>
          }
        />
        <Route path='billing' element={<Navigate to='/renovacao' replace />} />
        <Route
          path='marmorarias'
          element={
            <SuspensedView>
              <AdminProtectedRoute>
                <CompaniesPage />
              </AdminProtectedRoute>
            </SuspensedView>
          }
        />
        <Route
          path='financas'
          element={
            <SuspensedView>
              <AdminProtectedRoute>
                <BudgetManagementPage />
              </AdminProtectedRoute>
            </SuspensedView>
          }
        />
        <Route
          path='comissoes'
          element={
            <SuspensedView>
              <CommissionsPage />
            </SuspensedView>
          }
        />
        <Route
          path='comissoes/:id'
          element={
            <SuspensedView>
              <CommissionDetailsPage />
            </SuspensedView>
          }
        />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }

